import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { JobsRoutingModule } from "./jobs-routing.module";
import { SearchComponent } from "./search/search.component";
import { SharedModule } from "@app/view/shared";
import { AddVisitDialogComponent } from "./add-visit-dialog/add-visit-dialog.component";
import { ShowSchedulesDialogComponent } from "./show-schedules-dialog/show-schedules-dialog.component";
import { ManageAttendanceDialogComponent } from "./manage-attendance-dialog/manage-attendance-dialog.component";
import { UrmIntegrationModule } from "@app/integrations/urm/urm-integration.module";
import { CancelVisitDialogComponent } from "./cancel-visit-dialog/cancel-visit-dialog.component";
import { MeetingDetailPageComponent } from "./meeting-detail-page/meeting-detail-page.component";

@NgModule({
  exports: [],
  imports: [
    CommonModule,
    SharedModule,
    JobsRoutingModule,
    UrmIntegrationModule,
    SearchComponent,
    AddVisitDialogComponent,
    ShowSchedulesDialogComponent,
    ManageAttendanceDialogComponent,
    // VisitCardComponent,
    CancelVisitDialogComponent,
    MeetingDetailPageComponent
  ]
})
export class JobsModule {}
